import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Chift\CreateCompanyConsumerController::__invoke
* @see app/Http/Controllers/Chift/CreateCompanyConsumerController.php
* @route '/api/company/{company}/chift/consumer'
*/
const CreateCompanyConsumerController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateCompanyConsumerController.url(args, options),
    method: 'post',
})

CreateCompanyConsumerController.definition = {
    methods: ["post"],
    url: '/api/company/{company}/chift/consumer',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Chift\CreateCompanyConsumerController::__invoke
* @see app/Http/Controllers/Chift/CreateCompanyConsumerController.php
* @route '/api/company/{company}/chift/consumer'
*/
CreateCompanyConsumerController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return CreateCompanyConsumerController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Chift\CreateCompanyConsumerController::__invoke
* @see app/Http/Controllers/Chift/CreateCompanyConsumerController.php
* @route '/api/company/{company}/chift/consumer'
*/
CreateCompanyConsumerController.post = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateCompanyConsumerController.url(args, options),
    method: 'post',
})

export default CreateCompanyConsumerController